const MESES_NOMBRE = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

/**
 * Parámetro `?periodo=YYYY-MM` del deep-link a una liquidación (ej. el que va en la
 * notificación "Ya está lista tu liquidación de Septiembre 2026") → label del período tal
 * cual lo usa MetricsLiquidacionTab ("Septiembre 26"). `null` si el parámetro falta o no es un
 * año-mes válido: en ese caso el link simplemente abre la lista, sin expandir nada.
 */
export function periodoParamToLabel(param: string | null | undefined): string | null {
  const month = periodoParamToMonth(param);
  if (!month) return null;
  const [year, mm] = month.split('-').map((n) => parseInt(n, 10));
  return `${MESES_NOMBRE[mm - 1]} ${String(year % 100).padStart(2, '0')}`;
}

/**
 * Mismo parámetro `?periodo=YYYY-MM`, pero devuelto como el mes 'YYYY-MM' que usa el selector
 * de la vista NZ/range (`NZLiquidacionSchedule`, `schedule[].month`). `null` si falta o es
 * inválido.
 */
export function periodoParamToMonth(param: string | null | undefined): string | null {
  const match = /^(\d{4})-(0[1-9]|1[0-2])$/.exec((param ?? '').trim());
  return match ? `${match[1]}-${match[2]}` : null;
}
